import {
    setAIVoicesRequestFailed,
    setAIVoicesRequestStarted,
    setAIVoicesRequestSucceeded,
} from './ai-voices-slices';

import type { AIVoice, AiVoiceV2ListData } from 'js/src/client';
import { ApiService } from 'js/src/client';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import Flags from 'js/src/libs/flags';
import type { AppDispatch } from 'js/src/libs/RootState';
import uuid from 'js/src/libs/uuid';

const parseNextPage = (nextLink: string | null): number | null => {
    if (!nextLink) {
        return null;
    }
    const { search } = new URL(nextLink);
    const queryParams = new URLSearchParams(search);
    const page = queryParams.get('page');
    if (!page) {
        return null;
    }
    const nextPage = parseInt(page, 10);
    return nextPage;
};

export const fetchAIVoices = (query: AiVoiceV2ListData['query'] = {}) => {
    return async (dispatch: AppDispatch) => {
        const requestId = uuid();
        dispatch(setAIVoicesRequestStarted(requestId));

        try {
            let nextPage = null;
            const voices: AIVoice[] = [];
            if (Flags.canUseNewAiVoiceoverModal()) {
                const response = await ApiService.aiVoiceV2List({ query });
                nextPage = parseNextPage(response.data.next);
                voices.push(...response.data.results);
            } else {
                const response = await ApiService.aiVoiceList();
                voices.push(...response.data);
            }

            dispatch(setAIVoicesRequestSucceeded({ requestId, voices, nextPage }));
            return true;
        } catch (error) {
            ErrorReporter.capture(error);
            dispatch(setAIVoicesRequestFailed({ requestId, error: String(error) }));
            return false;
        }
    };
};
